

import Calendar from "./Calendar";
import SkillsField from "./SkillsField";

import WhoAmI from "./Who";
const About = () => {
    return (

        <div className="About_Page">
            <WhoAmI/>
            <SkillsField/>

            <Calendar/>

        </div>

    )

}

export default About;